import React from "react";

function NextButton({ condition = true, handleChange }) {
  return (
    <>
      {condition ? (
        <button
          type="button"
          className="btn-solid btn-primary text-base capitalize px-7 py-2 sm:px-8 sm:py-3 rounded-lg sm:inline-block w-full sm:w-auto"
          onClick={handleChange}
        >
          Next
        </button>
      ) : (
        <button
          type="button"
          className="border border-purple-400 text-purple-600 opacity-50 cursor-default text-base capitalize px-7 py-2 sm:px-8 sm:py-3 rounded-lg sm:inline-block w-full sm:w-auto"
          disabled
        >
          Next
        </button>
      )}
    </>
  );
}

export default NextButton;
